import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
import { Card } from '../ui/Card';
const data = [{
  name: 'Mai',
  sales: 40000
}, {
  name: 'Jun',
  sales: 30000
}, {
  name: 'Jul',
  sales: 60000
}, {
  name: 'Ago',
  sales: 55000
}, {
  name: 'Set',
  sales: 85000
}, {
  name: 'Out',
  sales: 125000
}];
export function SalesChart() {
  return <Card className="p-6 h-[400px]" data-id="element-45">
      <div className="flex justify-between items-center mb-6" data-id="element-46">
        <div data-id="element-47">
          <h3 className="text-lg font-bold text-white" data-id="element-48">Evolução de Vendas</h3>
          <p className="text-sm text-text-muted" data-id="element-49">Últimos 6 meses</p>
        </div>
        <select className="bg-slate-800 border border-slate-700 text-xs rounded-lg px-2 py-1 text-text-secondary focus:outline-none" data-id="element-50">
          <option data-id="element-51">Este ano</option>
          <option data-id="element-52">Ano passado</option>
        </select>
      </div>

      <div className="h-[300px] w-full" data-id="element-53">
        <ResponsiveContainer width="100%" height="100%" data-id="element-54">
          <AreaChart data={data} data-id="element-55">
            <defs data-id="element-56">
              <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1" data-id="element-57">
                <stop offset="5%" stopColor="#6366F1" stopOpacity={0.3} data-id="element-58" />
                <stop offset="95%" stopColor="#6366F1" stopOpacity={0} data-id="element-59" />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#334155" vertical={false} data-id="element-60" />
            <XAxis dataKey="name" stroke="#94A3B8" fontSize={12} tickLine={false} axisLine={false} data-id="element-61" />
            <YAxis stroke="#94A3B8" fontSize={12} tickLine={false} axisLine={false} tickFormatter={value => `R$${value / 1000}k`} data-id="element-62" />
            <Tooltip contentStyle={{
            backgroundColor: '#1E293B',
            border: '1px solid #334155',
            borderRadius: '8px'
          }} itemStyle={{
            color: '#F1F5F9'
          }} formatter={(value: number) => [`R$ ${value.toLocaleString()}`, 'Vendas']} data-id="element-63" />
            <Area type="monotone" dataKey="sales" stroke="#6366F1" strokeWidth={3} fillOpacity={1} fill="url(#colorSales)" data-id="element-64" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>;
}